<template>
    <div>
        <div  class="bg-white pb-6"  style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; height: auto;">
            <div class="fs-14 fw-500 px-8 bg-color py-2 mb-4">
                <div  class="d-flex justify-content-between align-items-center">
                    <div>
                        <span class="fw-600 fs-14">Follow Up Info</span>
                    </div>
                    <div>
                        <button class="btn btn-follow btn-wide px-6" @click="createReminder">+ Follow Up Reminder</button>
                    </div>
                </div>
            </div>
            <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100" style="height: 500px">
                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                    style="margin: 0 auto;" />
            </div>
            <div v-if="!ajaxCallInProgress && reminders_list.length == 0">
                <div class="text-center fs-14 fw-500 mt-8" style="height: 200px;"> No Follow Ups added!</div>
            </div>
            <div class="row px-5" v-else-if="!ajaxCallInProgress && reminders_list.length != 0">
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-3 px-1" v-for="(reminder,rem_index) in reminders_list" :key="rem_index">
                    <div class="mt-2 mx-2 bordrad-5px position-relative" style="box-shadow: 0 4px 8px 0 #cdd2da;">
                        <div class="d-flex">
                            <div class="w-25 p-3" style="border-right:1px solid #cdd2da">
                                <div class="calendar-custom text-center position-relative">
                                    <div class="calendar-holder" style="left: 15%"></div>
                                    <div class="calendar-holder" style="right: 15%"></div>
                                    <div class="text-white" style="border-bottom:3px solid #abc1e5;">{{reminder.month}}</div>
                                    <div class="text-white fs-15 fw-600">{{reminder.day}}</div>
                                </div>
                                <div class="mt-3 text-center">
                                    <div class="text-secondary fs-12 overflowing-text fw-500" :title="reminder.weekday">{{reminder.weekday}}</div>
                                    <div class="text-secondary fs-12">{{reminder.remind_time}}</div>
                                </div>
                            </div>
                            <div class="w-75 p-3">
                                <div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="fw-600 fs-15 overflowing-text text-capitalize text-nowrap" :title="reminder.reminder_title">{{reminder.reminder_title}}</div>
                                        <div class="d-flex">
                                            <i class="icon icon-eye fs-20 text-dark-blue w-1re pointer" @click="viewReminder(reminder.id, reminder.recurring_id)"></i>
                                            <i class="icon icon-pencil fs-20 pointer text-dark-blue ml-2 w-1re" v-if="(reminder.is_edit && userPermissions.reminders.permitted_actions.edit && reminder.origin != 'call_report')" @click="editReminder(reminder.id, reminder.recurring_id)"></i>
                                            <i class="icon icon-trash fs-20 pointer text-dark-blue ml-2 w-1re" v-if="userPermissions.reminders.permitted_actions.delete && reminder.is_delete && reminder.origin != 'call_report'" @click="DeleteSelectedReminder(reminder.id, reminder.recurring_id)"></i>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="fs-14 overflowing-text sub-txt fw-500 mt-1 text-capitalize">{{reminder.reminder_type.replaceAll("_", " ")}}</div>
                                        <div v-if="reminder.repeat_details.repeat_cycle_type == 'annually'" class="fs-14 overflowing-text sub-txt fw-500 mt-1 text-capitalize"> Year : {{reminder.year}}</div>
                                    </div>
                                    <!-- <div v-if="(reminderType == 'My Reminders' || reminderType == 'Invitations' && (reminder.type == 'follow_up' || reminder.type == 'task'))" class="d-flex">    
                                        <div class="fs-12 overflowing-text sub-txt fw-500 mt-1 text-capitalize d-flex">Assigned to : <div class="text-truncate" style="max-width: 100px !important;padding-left: 4px;" :title="reminder.invitees[0].full_name"> {{ reminder.invitees.length == 0 ? '-' : reminder.invitees[0].full_name }}</div></div>
                                        <div v-if="reminder.invitees.length > 1">
                                            <el-popover
                                                placement="bottom"
                                                width="auto"
                                                trigger="hover">
                                                <span v-for="(assgned_to, assgned_to_index) in reminder.invitees" :key="assgned_to_index">
                                                    <span v-if="assgned_to_index > 0" class="fw-500 custom_chips">{{assgned_to.full_name}}</span>
                                                </span>
                                                <el-button slot="reference" style="background-color: transparent;font-weight: 500 !important;font-size: 14px !important;padding: 5px 8px !important;" >
                                                    <div class="fw-500 mt-4px text-center text-secondary">
                                                        +{{reminder.invitees.length - 1}} more
                                                    </div>
                                                </el-button>
                                            </el-popover><br>
                                        </div>
                                    </div> -->
                                    <div class="fs-12 overflowing-text sub-txt fw-500 mt-1 text-capitalize">Invited by : {{reminder.created_by_name || "-"}}</div>
                                    <div class="d-flex justify-content-between mt-1">
                                        <div class="fs-12 overflowing-text sub-txt fw-500">
                                            <span>Remind Before :</span>
                                            <span class="ml-2 remind-time">
                                                {{reminder.remind_cycle_period}}
                                                <span v-if="reminder.remind_period < 2">
                                                    {{reminder.remind_cycle_type == 'minute' ? 'Min' : reminder.remind_cycle_type == 'hour' ? 'Hr' : reminder.remind_cycle_type == 'day' ? 'Day' : ''}}
                                                </span>
                                                <span v-else>
                                                    {{reminder.remind_cycle_type == 'minute' ? 'Mins' : reminder.remind_cycle_type == 'hour' ? 'Hrs' : reminder.remind_cycle_type == 'day' ? 'Days' : ''}}
                                                </span>
                                            </span>
                                        </div>
                                        <div class="fs-12 overflowing-text sub-txt fw-500 text-capitalize" :class="reminder.status == 'pending' ? 'text-warning' : 'completed' ? 'text-success' : ''">{{reminder.status}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Pagination Section -->
            <div v-if="!ajaxCallInProgress && reminders_list.length > 0" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <delete-event @hideDeleteEvent="hideDeleteEvent" :selected_id="selected_id" v-if="delete_event" modal_name="deleteEvent" @deleteReminder="deleteReminder"></delete-event>
        <create-reminder v-if="createReminderShow" :lead_edit_stage="lead_edit_stage" :lead_current_stage="lead_current_stage" :meeting_type="meeting_type" :from_module="from_module" :mode_id="mode_id" :recurring_id="recurring_id" :view_mode="view_mode" modal_name="createReminder" @hideCreateReminder="hideCreateReminder" @hideCreateReminderSave="hideCreateReminderSave"></create-reminder>
    </div>
</template>
<script>
    const CreateReminder = () => import("../Reminders/CreateReminder.vue");
    import reminders from "../mixins/reminders"
    import { HalfCircleSpinner } from "epic-spinners";
    import { SweetModal } from 'sweet-modal-vue';
    const DeleteEvent = () => import('../alertModals/DeleteReminderEvent')
    import schedule from "../mixins/scheduleMeeting.js"
    import contacts from '../mixins/contacts'
    import customer from '../mixins/customer';
    import leads from "../mixins/leads";
    export default {
    data(){
        return{
            success_msg: '',
            warning_msg: "",
            ajaxCallInProgress: false,
            limit: 10,
            skip: 0,
            pageLimit: [],
            total: 0,
            skip_temp:0,
            temp_total:0,
            count: 0,
            reminders_list: [],
            mode_id: '',
            recurring_id: '',
            view_mode: 'create',
            createReminderShow: false,
            selected_id: '',
            delete_event: false,
            meeting_type: "",
            reminder_ids: "",
            from_module: "",
            lead_current_stage: "",
            lead_edit_stage: ""
        }
    },
    mixins:[reminders, schedule, contacts, customer, leads],
    components: {HalfCircleSpinner, CreateReminder, DeleteEvent, SweetModal},
    methods:{
        async getMeetingData(){
            this.ajaxCallInProgress = true
            let params = {
                id: this.$route.params.id
            }
            let response = await this.getScheduleMeetingById(params)
            this.meeting_details = response.response
            this.reminder_ids = this.meeting_details.reminders
            if(this.meeting_details.reminders == null){
                this.ajaxCallInProgress = false
                this.reminders_list.length == 0
            }else{
                this.loadReminders();
            }
            // this.ajaxCallInProgress = false
        },
        async loadReminders(){
            this.ajaxCallInProgress = true
            let category = ''
            let status = ''
            try{
                if(this.$route.params.module_type == 'contacts'){
                    let params = {
                        "product_name": "CRM",
                        "contact_id": this.$route.params.id,
                        "skip": this.skip,
                        "limit": this.limit == '' || 0 || null || undefined ? 9 : this.limit,
                        "filter_reminders": this.reminder_ids ? this.reminder_ids : '',
                        "search_key": "",
                        "sort_value": 1,
                        "sort_key": "id",
                    }
                    let response = await this.getContactRemindersList(params);
                    this.reminders_list = response.response
                    this.ajaxCallInProgress = false
                    this.total = response.total_count
                    this.ajaxCallInProgress = false
                }else if(this.$route.params.module_type == 'customers'){
                    let params = {
                        "product_name": "CRM",
                        "search_key": "",
                        "sort_value": 1,
                        "sort_key": "id",
                        "customer_id": this.$route.params.id,
                        "filter_reminders": this.reminder_ids ? this.reminder_ids : '',
                        "skip": this.skip,
                        "limit": this.limit == '' || 0 || null || undefined ? 9 : this.limit
                    }
                    let response = await this.getCustomerRemindersList(params);
                    this.reminders_list = response.response
                    this.ajaxCallInProgress = false
                    this.total = response.total_count
                }else if(this.$route.params.module_type == 'leads'){
                    let params = {
                        product_name: "CRM",
                        skip: this.skip,
                        limit: this.limit == '' || 0 || null || undefined ? 9 : this.limit,
                        search_key: "",
                        sort_value: 1,
                        "filter_reminders": this.reminder_ids ? this.reminder_ids : '',
                        sort_key: "id",
                        lead_id: this.$route.params.id,
                        stage_name: this.$route.params.stage_name
                    }
                    let response = await this.getLeadsActiveRemindersList(params)
                    this.reminders_list = response.response
                    this.total = response.total_count
                    this.ajaxCallInProgress = false
                }else{
                    let params = {
                        product_name: "CRM",
                        skip: this.skip,
                        limit: this.limit == '' || 0 || null || undefined ? 9 : this.limit,
                        search_key: "",
                        category: category,
                        "filter_reminders": this.reminder_ids ? this.reminder_ids : '',
                        filter_json:{
                            status: status,
                        }
                    }
                    let response = await this.getToolRemindersList(params)
                    this.reminders_list = response.response
                    this.total = response.total_count
                    this.ajaxCallInProgress = false
                }
            }catch(error){

            }
        },
        createReminder(){
            if(this.$route.params.module_type == 'contacts'){
                this.from_module = 'contact'
                this.recurring_id = this.$route.params.id
            }else if(this.$route.params.module_type == 'customers'){
                this.from_module = 'customer'
                this.recurring_id = this.$route.params.id
            }else if(this.$route.params.module_type == 'leads'){
                this.from_module = 'leads'
                this.recurring_id = this.$route.params.id
            }else{
                this.from_module = 'tools'
                this.recurring_id = this.$route.params.id
            }
            this.meeting_type = "meeting"
            this.mode_id = this.$route.params.module_id
            this.view_mode = 'create'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        },
        hideCreateReminderSave(){
            this.createReminderShow = false;
            this.mode_id = ''
            this.recurring_id = ''
            this.view_mode = 'create'
            this.getMeetingData();
        },
        hideCreateReminder(){
            this.createReminderShow = false;
        },
        viewReminder(id, rec_id){
            if(this.$route.params.module_type == 'contacts'){
                this.from_module = 'contact'
            }else if(this.$route.params.module_type == 'customers'){
                this.from_module = 'customer'
            }else if(this.$route.params.module_type == 'leads'){
                this.from_module = 'leads'
            }else{
                this.from_module = 'tools'
                this.recurring_id = this.$route.params.id
            }
            this.meeting_type = "meeting"
            this.mode_id = id
            this.recurring_id = rec_id
            this.view_mode = 'view'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        },
        editReminder(id, rec_id){
            this.meeting_type = "meeting"
            this.mode_id = id
            this.recurring_id = rec_id
            this.view_mode = 'edit'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        },
        DeleteSelectedReminder(id, rec_id){
            this.selected_id = id;
            this.recurring_id = rec_id
            this.delete_event = true
            setTimeout(() => {
                this.$modal.show('deleteEvent')
            }, 500);
        },
        hideDeleteEvent(){
            this.delete_event = false
            this.selected_id = ''
        },
        //API call to delete selected reminder
        async deleteReminder($event) {
            try{
            let response = await this.DeleteToolReminderById(this.selected_id, this.recurring_id, $event);
                if (response.status_id == 1) {
                    this.hideDeleteEvent();
                    this.selected_id = "";
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.loadReminders();
                    }, 3000);
                }else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }

        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.skip_temp = 0
            this.loadReminders()
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.loadReminders()
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.loadReminders()
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.loadReminders()
        },
    },
    mounted(){
        this.lead_current_stage = this.$route.params.stage_name
        this.lead_edit_stage = this.$route.params.stage_name
        this.getMeetingData();
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        
    },
    created() {
       
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    watch: {
    },
}
</script>
<style>
    .bg-color{
        background-color: #00448b;
        color:#fff !important;
        border-radius: 4px;
    }
    .btn-follow{
        color: #218b08;
        background-color: #fff;
    }
    .calendar-custom{
        height:50px;
        width:50px;
        background-color: #0d5be6;
        border:3px solid #abc1e5;
        border-radius:6px;
        margin:auto
    }
    .calendar-holder{
        width: 4px;
        height: 11px;
        background-color: rgb(171, 193, 229);
        position: absolute;
        top: -9px;
        border-radius: 10px;
    }
    .text-dark-blue {
          color: #00448b;
    }
    .overflowing-text{
          overflow: hidden;
          text-overflow: ellipsis;
     }
     .w-25{
        width: 25% !important;
     }
     .w-75{
        width: 75% !important;
     }
     .sub-txt{
        font-weight: 500;
        line-height: 1.82;
        text-align: left;
        color: #707070;
     }
     .remind-time{
        background: #128807;
        color: #fff;
        padding: 8px;
        border-radius: 100%;
        white-space: nowrap;
     }
     .bordrad-5px {
          border-radius: 5px !important;
     }
     .w-1re{
        width: 1.5rem !important;
     }
    .custom_chips{
        display: inline-flex;
        padding: 3px 12px;
        background: #dfe8f4;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 12.5px;
        cursor: pointer;
        color: #4e5764;
    }
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/FollowUpTab.vue